import React, {Component} from 'react';
import {injectIntl, intlShape} from 'react-intl';
import OfferTile from './OfferTile';
import _ from 'lodash';
import GriffinNumber from 'griffin-paypal/lib/client/number';
import {connect} from 'react-redux';
import { CREDIT_TYPE } from '../../framework/App/AppConstants';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

export class OfferTileGroup extends Component {
    static propTypes = {
        cycoFinancingOptions: PropTypes.array.isRequired,
        griffinNumberHandler: PropTypes.object.isRequired,
        localePrefix: PropTypes.string.isRequired
    };

    static formatCurrency(griffinNumberHandler, currencyCode, amount = 0) {
        return griffinNumberHandler.formatCurrency({
            currency: currencyCode,
            value: amount
        });
    }

    static getOfferTiles(financingOptions, griffinNumberHandler, localePrefix) {

        const installmentOfferTiles = [];
        const nonInstallmentOfferTiles = [];

        const sortedFinancingOptions = _.sortBy(financingOptions, (offerDetails) => _.get(offerDetails, 'credit_financing.term'));

        _.forEach(sortedFinancingOptions, offerDetails=> {

            const financingCode = _.get(offerDetails, 'credit_financing.financing_code');
            const creditType = _.get(offerDetails, 'credit_financing.credit_type');

            if (creditType === CREDIT_TYPE.INSTALLMENTS) {
                const currencyCode = _.get(offerDetails, 'total_cost.currency_code');
                const paymentDuration = _.get(offerDetails, 'credit_financing.term');
                const apr = _.toNumber(_.get(offerDetails, 'credit_financing.apr'));
                const paymentRate = OfferTileGroup.formatCurrency(griffinNumberHandler, currencyCode, _.get(offerDetails, 'monthly_payment.value'));
                const totalInterestAmount = OfferTileGroup.formatCurrency(griffinNumberHandler, currencyCode, _.get(offerDetails, 'total_interest.value'));
                const totalCostAmount = OfferTileGroup.formatCurrency(griffinNumberHandler, currencyCode, _.get(offerDetails, 'total_cost.value'));

                installmentOfferTiles.push(
                    <Field
                        id={`control_${financingCode}`}
                        name="offer"
                        paymentRate={paymentRate}
                        paymentDuration={paymentDuration}
                        apr={`${apr}%`}
                        totalInterestAmount={totalInterestAmount}
                        totalCostAmount={totalCostAmount}
                        financingCode={financingCode}
                        isInstallment={true}
                        key={financingCode}
                        component={OfferTile}
                        localePrefix={localePrefix}
                    />
                );
            } else if (nonInstallmentOfferTiles.length === 0 || creditType === CREDIT_TYPE.NO_INTEREST) {
                // Match the existing behavior of the Hermes:
                // Add only one NI offer to the tiles group.
                // If there are more than one (e.g., NI and SAC), then overwrite only if the current offer type is NI.
                nonInstallmentOfferTiles[0] = (
                    <Field
                        id={`control_${financingCode}`}
                        name="offer"
                        financingCode={financingCode}
                        key={financingCode}
                        component={OfferTile}
                        localePrefix={localePrefix}
                    />
                );
            }
        });

        return _.concat(installmentOfferTiles, nonInstallmentOfferTiles);
    }

    render() {
        const { cycoFinancingOptions, griffinNumberHandler, localePrefix } = this.props;
        const offerTiles = OfferTileGroup.getOfferTiles(cycoFinancingOptions, griffinNumberHandler, localePrefix);

        return (
            <div className="offerTiles-group">
                {offerTiles}
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    cycoFinancingOptions: state.serverData.cycoFinancingOptions || [],
    griffinNumberHandler: GriffinNumber.createHandler(state.serverData.localityMetadata)
});


export default connect(mapStateToProps)(injectIntl(OfferTileGroup));
